// ============================================================
// Core game types for TriggernometryDash
// ============================================================

/** Level modes corresponding to number domains */
export type LevelMode = 'real' | 'imaginary' | 'complex';

/** Player movement modes */
export type PlayerMode = 'triangle' | 'wave_rider' | 'orbiter' | 'tangent' | 'phase_shifter';

/** Game state machine states */
export type GameState = 'menu' | 'loading' | 'playing' | 'paused' | 'dead' | 'complete' | 'results';

/** Difficulty tiers */
export type Difficulty = 'easy' | 'normal' | 'hard' | 'insane' | 'triggered';

/** 2D vector */
export interface Vec2 {
  x: number;
  y: number;
}

/** 3D vector */
export interface Vec3 {
  x: number;
  y: number;
  z: number;
}

/** RGBA color */
export interface Color {
  r: number;
  g: number;
  b: number;
  a: number;
}

/** Rectangle bounds for collision */
export interface Rect {
  x: number;
  y: number;
  width: number;
  height: number;
}

/** Parse a hex color string to Color */
export function hexToColor(hex: string): Color {
  const h = hex.replace('#', '');
  return {
    r: parseInt(h.substring(0, 2), 16) / 255,
    g: parseInt(h.substring(2, 4), 16) / 255,
    b: parseInt(h.substring(4, 6), 16) / 255,
    a: 1.0,
  };
}

/** Convert Color to vec4 array for shaders */
export function colorToVec4(c: Color): [number, number, number, number] {
  return [c.r, c.g, c.b, c.a];
}
